import api from "../../app/api";

export const unSubscribeList = async (data) => {
  const response = await api.post(`/notification/email/unsubscribe`, data);
  return response.data;
};

